<template>
  <div>
    <el-card>
      <el-upload
        class="upload-demo"
        drag
        :data="{ token: $store.getters.token.split(' ')[1] }"
        action="/tii/ew/upload"
        :before-upload="beforeUpload"
        :on-success="getquerylist"
        multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </el-card>
    <el-table
      v-loading="tableloading"
      :data="list"
      style="width: 100%"
    >
      <el-table-column
        prop="fileName"
        label="文件名">
      </el-table-column>
      <el-table-column
        prop="oId"
        label="oId">
      </el-table-column>
      <el-table-column
        prop="simRate"
        label="重复率">
        <template slot-scope="scope">
          <div v-if="scope.row.state==='查询完成'">
            <span style="font-size: 20px;color: #ff0000">{{ scope.row.simRate }}%</span>
            <el-button type="text" size="mini" @click="downloadreport($event,'similarity',scope.row.id,scope.row.fileName)">下载</el-button>
          </div>
          <el-tag v-else type="info" size="mini">查询中</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="aiRate"
        label="AI率">
        <template slot-scope="scope">
          <div v-if="scope.row.state==='查询完成'">
            <div v-if="Number.isInteger(parseFloat(scope.row.aiRate)) && scope.row.aiRate.trim() === scope.row.aiRate">
              <span style="font-size: 20px;color: #ff0000">{{ scope.row.aiRate }}%</span>
              <el-button type="text" size="mini" @click="downloadreport($event,'ai',scope.row.id,scope.row.fileName)">下载报告</el-button>
            </div>
            <el-tag v-else size="mini" type="warning">{{ scope.row.aiRate }}</el-tag>
          </div>
          <el-tag v-else type="info" size="mini">查询中</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === '查询完成'" type="success">{{ scope.row.state }}</el-tag>
          <el-tag v-else type="wrong">{{ scope.row.state }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="right">
        <template slot="header" slot-scope="scope">
          <el-button type="text" size="small" @click="getquerylist">刷新</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Tii',
  data() {
    return {
      tableloading: false,
      dialogVisible: false,
      list:[]
    }
  },
  mounted() {
    this.getquerylist();
  },
  methods: {
    downloadreport(event,reporttype,id,fileName) {
      axios({
        url: '/tii/ew/downloadreport', // 替换成实际的文件URL
        method: 'GET',
        responseType: 'blob', // 必须设置为blob以处理二进制文件下载
        params: {
              token: this.$store.getters.token.split(' ')[1],
              id: id,
              type: reporttype
            }
      })
        .then(response => {
          // 创建一个链接元素，用于下载
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',reporttype+'_'+fileName+'.pdf'); // 替换文件名和扩展名
          document.body.appendChild(link);
          link.click();
          link.remove(); // 下载后移除元素
          window.URL.revokeObjectURL(url); // 释放URL对象
        })
        .catch(error => {
          console.log(error);
        });
    },
    beforeUpload(file) {
      const fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
      const allowedExtensions = ['doc', 'docx','pdf'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.$message.error('只能上传 .doc 或 .docx 文件.pdf');
        return false;
      }
      return true; // 返回 true 允许上传，false 则阻止上传
    },
    getquerylist() {
      let parts = this.$store.getters.token.split(" ");
      let jwt = parts[1];
      this.tableloading = true;
      axios.get('/tii/ew/querylist',{
        params: {
          token: jwt
        }
      })
        .then(response => {
          this.list = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.tableloading = false;
        });
    }
  }
}

</script>
<style scoped>

</style>
